import HeroPageTemplate from './HeroPageTemplate';

export default HeroPageTemplate;
